import {Injectable} from '@angular/core';
import {Formatter} from 'src/app/domain/formatter/formatter';
import {removeSpaces} from 'src/app/domain/function/string.helper';

@Injectable({
  providedIn: 'root'
})
export class PhoneFormatter implements Formatter {
  format(value: any): any {
    return value.replace(/[^\dA-Z]/g, '').replace(/(.{3})/g, '$1 ').trim();
  }

  normalize(value: string): string {
    return removeSpaces(value);
  }
}
